import { useIntl } from 'react-intl';

import NextImage from '@/components/image/NextImage';
import { schoolsLogos } from '@/components/schools/Hero/data';
import { SchoolSectionProps } from '@/components/schools/SchoolsLayout/types';
import { SupportedSchoolLanguage } from '@/components/schoolsResources/Guides/types';
import { useLocale } from '@/hooks/locale/useLocale';

import messages from './messages';
import {
	Arrow,
	Background,
	Content,
	Cta,
	Divider,
	Grid,
	Heading,
	Image,
	Logo,
	MobileImage,
	Wrapper,
} from './styles';

const Hero = ({ onCtaClick }: SchoolSectionProps) => {
	const { formatMessage } = useIntl();
	const { calmLanguage } = useLocale();
	const logo = schoolsLogos[calmLanguage as SupportedSchoolLanguage] || schoolsLogos.en;

	return (
		<>
			<Wrapper>
				<Background src="/_n/images/schools/hero-collage-background.webp" objectPosition="bottom center" />
				<Grid>
					<Content>
						<Logo as={logo} />
						<Heading>{formatMessage(messages.body)}</Heading>
						<Cta backgroundColor="transparent" onPress={() => onCtaClick(messages.body.defaultMessage)}>
							{formatMessage(messages.cta)}
							<Arrow />
						</Cta>
					</Content>
				</Grid>
				<MobileImage>
					<NextImage
						fill
						style={{ objectFit: 'contain', objectPosition: 'top right' }}
						src="/_n/images/schools/hero-mobile-girl-smiling.webp"
						alt="Girl laughing"
					/>
				</MobileImage>
				<Image src="/_n/images/schools/desktop-hero-image.webp" />
			</Wrapper>
			<Divider src="/_n/images/schools/hero-torn-paper.webp" />
		</>
	);
};

export default Hero;
